import React, { useState, useEffect, useRef, useMemo } from "react";
import { useLocation, useHistory, useParams } from "react-router-dom";
import "../../../assets/styles/admin/opd.scss";
import Personal from "./personal";
import OPDList from "./opdList";
import Hitory from "./history";
import HitoryDoctor from "./doctor/history";
import HeaderBar from "../../../components/header/headerBar";
import ModalSendMessage from "../../../components/antd/modalSendMessage";
import axios from "axios";
import { Icon } from "@iconify/react";
import { Button, Select, Row, Col, Input, Tabs } from "antd";
import { useSelector, useDispatch } from "react-redux";

interface ParamTypes {
  id?: string;
}

const PersonalHistory = () => {
  type PositionType = "2";
  const { TabPane } = Tabs;
  const history = useHistory();
  const { id } = useParams<ParamTypes>();
  const [isHidel, setIsHidele] = useState<boolean>(true);
  const [tabNumber, setTabNumber] = useState<number>(0);
  const [nameTitle, setNameTitle] = useState<string>("");
  const [position, setPosition] = useState<string>("1");
  const [positionv2, setPositionv2] = useState<any>();
  const [openModel, setOpenModel] = useState(false);
  const user = useSelector((state: any) => state.user);
  const permission = user?.permission;
  const onChangeHide = () => {
    setIsHidele(!isHidel);
  };
  const refHistory: any = useRef(null);

  const operations = () => {
    if (position === "2")
      return setPositionv2(
        permission.name === "CS" ? (
          <Button onClick={toCreateOpd}>Create Doctor Opinion</Button>
        ) : (
          ""
        )
      );

    return setPositionv2(null);
  };

  const getPrefixes = async (data: any) => {
    await axios.get(`/prefixes/${data?.prefix}`).then((res) => {
      setNameTitle(
        `${res?.data?.name}${data?.firstName ? data?.firstName : data?.firstNameEN
        } ${data?.lastName ? data?.lastName : data?.lastNameEN} (${data?.code})`
      );
    });
  };

  const getPersonal = async () => {
    await axios.get(`/member-opd/${id}`).then((res) => {
      getPrefixes(res?.data);
    });
  };

  const toPrint = async () => {
    history.push(`/opd/print/${id}?memberId=&medicalRecordId=&type=normal`);
  };

  const toCreateOpd = async () => {
    history.push(`/opd/list/create/${id}/create-opd`);
  };

  useEffect(() => {
    getPersonal();
  }, []);

  useEffect(() => {
    operations();
    console.log("position", position);
    if (position === "3") {
      console.log("position history...");
      refHistory?.current?.getData();
    }
  }, [position]);

  function toggleModal() {
    setOpenModel(!openModel);
  }

  return (
    <div>
      <HeaderBar title={`${nameTitle}`} onClick={history.goBack}>
        <ModalSendMessage
          show={openModel}
          cancelModal={toggleModal}
          opd_id={id}
          nameTitle={nameTitle}
        />
        <div className="justify-center">
          {permission.name === "Admin" || permission.name === "Sale" ? (
            <div className={isHidel ? "btn-edit" : "btn-edit-push"}>
              {position === "1" && (
                <Button onClick={onChangeHide} disabled={!isHidel}>
                  <Icon
                    icon="ant-design:edit-filled"
                    width="1.2rem"
                    height="1.2rem"
                    style={{
                      marginRight: "5px",
                      marginBottom: " 4px",
                    }}
                  />
                  Edit
                </Button>
              )}
            </div>
          ) : (
            ""
          )}
          {permission.name !== "CS" && (
            <div className="btn-send" style={{ marginLeft: "15px" }}>
              {position === "1" && (
                <Button
                  onClick={toggleModal}
                  style={{
                    background: "#ffffff",
                    color: "#e76464",
                  }}
                >
                  <Icon
                    icon="cil:send"
                    width="1.2rem"
                    height="1.2rem"
                    style={{ marginRight: "8px", marginBottom: " 4px" }}
                  />
                  Send
                </Button>
              )}
            </div>
          )}

          <div className="btn-print" style={{ marginLeft: "15px" }}>
            {position === "1" && (
              <Button onClick={toPrint}>
                <Icon
                  icon="ps:printer"
                  width="1.2rem"
                  height="1.2rem"
                  style={{ marginRight: "8px", marginBottom: " 4px" }}
                />
                Print OPD
              </Button>
            )}
          </div>
        </div>
      </HeaderBar>

      {position === "4" && (
        <>
          <div style={{ margin: "13px 40px 30px" }}>
            <div className="input-search">
              <Select
                bordered={false}
                placeholder="Search for SO"
                suffixIcon={
                  <Icon
                    icon="ant-design:caret-down-filled"
                    style={{ color: "#AEAEAE" }}
                  />
                }
                onChange={(e) => {
                  // setDataSearch({ ...dataSearch, typeSearch: e})
                  // setIsDisable({...isDisable, isSearch: true})
                }}
              // options={types}
              />
              <Input.Search
                bordered={false}
                // disabled={ isDisable?.isSearch ? false : true}
                onSearch={(e) => {
                  // setDataSearch({ ...dataSearch, search: e})
                }}
              />
            </div>
          </div>
        </>
      )}

      <div style={{ margin: "20px 40px" }} className="tabs-custom">
        <Tabs
          defaultActiveKey="1"
          type="card"
          tabBarExtraContent={positionv2}
          onChange={(e) => {
            setPosition(e);
          }}
        >
          <TabPane tab="Personal" key="1">
            <Personal editValue={isHidel} childToParent={onChangeHide} />
          </TabPane>
          <TabPane tab="Medical Record" key="2">
            <OPDList />
          </TabPane>
          {permission.name === "CS" ?
            <TabPane tab="History" key="3">
              <HitoryDoctor ref={refHistory} />
            </TabPane>
            :
            <TabPane tab="History" key="3">
              <Hitory ref={refHistory} />
            </TabPane>
          }

        </Tabs>
      </div>
    </div>
  );
};
export default PersonalHistory;
